// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarAdmin_navbar__wVmV9","logo":"NavbarAdmin_logo__2kmog","navLinks":"NavbarAdmin_navLinks__rNJ9i","navItem":"NavbarAdmin_navItem__lDX4g"};